import { formatAmount } from "./formatAmount";

/**
 * Function to transform cents to dollars stringified and with the USD format
 */
export const formatCentsToDollarString = (cents: number) => {
    return formatAmount("cent-to-dollar", cents).toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
    });
};
